module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10.37 10.37\"><path d=\"M.18 9.49q-.4-.4.09-.91l3.41-3.4-3.4-3.41Q-.21 1.28.19.88l.7-.7q.4-.4.9.09l3.4 3.41L8.59.27q.49-.49.9-.09l.7.7q.4.4-.09.89L6.69 5.19l3.41 3.4q.49.49.09.9l-.7.7q-.4.4-.9-.09l-3.4-3.41-3.41 3.41q-.49.49-.9.09z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/close.svg
// module id = srjS
// module chunks = 1